/**
 * @generated SignedSource<<b3c9e62ce853898279cadae1b73a2159>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CancellationReasonType = "unavailable_at_time" | "session_not_needed" | "found_another_practitioner" | "no_longer_need_support" | "other" | "practitioner_cancelled" | "cancelled_early" | "cancelled_late" | "no_show" | "%future added value";
export type CancellationType = "practitioner" | "guest" | "community" | "%future added value";
export type ConfirmationType = "completed" | "cancelled" | "%future added value";
export type ConfirmEventInput = {
  eventID: string;
  confirmationType: ConfirmationType;
  cancellationType?: CancellationType | null;
  cancellationReasonType?: CancellationReasonType | null;
  cancellationReason?: string | null;
};
export type eventConfirmMutation$variables = {
  input: ConfirmEventInput;
};
export type eventConfirmMutation$data = {
  readonly confirmEvent: boolean;
};
export type eventConfirmMutation = {
  variables: eventConfirmMutation$variables;
  response: eventConfirmMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "confirmEvent",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8416e1b54f18747da5121169eedc7d9d",
    "id": null,
    "metadata": {},
    "name": "eventConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation eventConfirmMutation(\n  $input: ConfirmEventInput!\n) {\n  confirmEvent(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "cf8103a2c20aef834653791c8c405363";

export default node;
